import { Alert, Button, MenuItem, Stack, TextField } from '@mui/material';
import { LEAD_SOURCE_LABELS, LeadSourceType } from '@sr/dto';
import { useSearchParams } from 'react-router-dom';
import { leadSourceChoicesApi } from 'entities/lead/lead-source-choices.api';
import { PAGE_FIELD_NAME } from 'shared/hooks/paging-params';

export const LeadSourceFilter = () => {
  const [params, setParams] = useSearchParams();
  const { data: choices = [], isFetching, error, refetch } = leadSourceChoicesApi.useGetLeadSourceChoicesQuery();
  const type = params.get('sourceType') ?? '';
  const source = params.get('source2Id') ?? '';
  const items = choices.filter((item) => item.sourceType === type);
  const update = (key: string, value: string) => setParams((previous) => {
    const next = new URLSearchParams(previous);
    if (value) next.set(key, value); else next.delete(key);
    if (key === 'sourceType') next.delete('source2Id');
    next.delete(PAGE_FIELD_NAME);
    return next;
  }, { replace: true });

  return <Stack spacing={2}>
    <TextField select size="small" label="Тип источника" value={type} InputLabelProps={{ shrink: true }} SelectProps={{ displayEmpty: true }} onChange={(event) => update('sourceType', event.target.value)}>
      <MenuItem value="">Все</MenuItem>
      {Object.values(LeadSourceType).map((value) => <MenuItem key={value} value={value}>{LEAD_SOURCE_LABELS[value]}</MenuItem>)}
    </TextField>
    <TextField select size="small" label="Источник" value={source} disabled={!type || isFetching || !!error}
      InputLabelProps={{ shrink: true }} SelectProps={{ displayEmpty: true }}
      helperText={!type ? 'Сначала выберите тип источника' : isFetching ? 'Загрузка источников…' : 'Можно оставить все источники'}
      onChange={(event) => update('source2Id', event.target.value)}>
      <MenuItem value="">Все источники</MenuItem>
      {items.map((item) => <MenuItem key={item.id} value={String(item.id)}>{item.source2Name}</MenuItem>)}
      {source && !items.some((item) => String(item.id) === source) && <MenuItem value={source}>Источник № {source}</MenuItem>}
    </TextField>
    {error && <Alert severity="error" action={<Button onClick={() => refetch()}>Повторить</Button>}>Не удалось загрузить источники</Alert>}
  </Stack>;
};
